module.exports = __webpack_public_path__ + "static/media/highlights-on.523f1d7b.svg";